import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';

@Component({
  selector: 'app-dlg-tipos-sexo',
  templateUrl: './dlg-tipos-sexo.component.html',
  styleUrls: ['./dlg-tipos-sexo.component.css']
})
export class DlgTiposSexoComponent implements OnInit {

  titulo=""
  nombre=""
  habilitado=true
  idActual=""

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgTiposSexoComponent>,
  ) { }

  ngOnInit(): void {
    if (this.storage.get("idConexion")==null){
      this.router.navigate(['/'])
    }
    this.leerDato();
  }

  leerDato(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose:true
    });
    dlgTrabajando.componentInstance.titulo="";
    dlgTrabajando.componentInstance.texto="Buscando los datos del tipo de sexo";

    this.httpClient.get(environment.servidorHttp+'Sistema/leerTiposSexoDato'
      ,{
        params: {
          "idConexion": this.storage.get("idConexion"),
          "idTipoSexo": this.idActual,
        },
        headers:{
          "Authorization":'Bearer ' + this.storage.get("token"),
        }
      })
    .subscribe(data => {
      this.cerrarDialogo(dlgTrabajando);
      if (data['resultado']['msgError']['valorDevuelto']=="01"){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al buscar los datos del tipo de sexo";
        dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
      } else{
        this.titulo=data['resultado']['msgError']['titulo'];
        if (data['resultado']['msgError']['nombre']!=null){
          this.nombre=data['resultado']['msgError']['nombre'];
          this.habilitado=data['resultado']['msgError']['habilitado']=="1";
        }
      }
    },
    (error: HttpErrorResponse) => {
      this.cerrarDialogo(dlgTrabajando);
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      if (error.status.toString()=="401"){
        dlgError.componentInstance.titulo="Error al buscar los datos del tipo de sexo";
        dlgError.componentInstance.texto="Su sesión ha finalizado";
        this.router.navigate(['/']);
      }else{
        dlgError.componentInstance.titulo="Error al buscar los datos del tipo de sexo";
        dlgError.componentInstance.texto=error.message+" ("+error.status+")";
      }
    });
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena});
  }

  almacenar(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose: true
    });
    dlgTrabajando.componentInstance.titulo = "";
    dlgTrabajando.componentInstance.texto = "Intentando almacenar el tipo de sexo";

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('idConexion', this.storage.get("idConexion"));
    urlSearchParams.append('idTipoSexo', this.idActual);
    urlSearchParams.append('nombre', this.nombre);
    urlSearchParams.append('habilitado', this.habilitado.toString());
    
    let parametros = urlSearchParams.toString()
    this.httpClient.post(environment.servidorHttp + 'Sistema/modificarTiposSexo?' + parametros, null,
      {
        headers: {
          "Authorization": "Bearer " + this.storage.get("token") 
        },
      })
      .subscribe(data => {
        this.cerrarDialogo(dlgTrabajando);
        if (data['resultado']['msgError']['valorDevuelto'] == "01") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al almacenar el tipo de sexo";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        } else if (data['resultado']['msgError']['valorDevuelto'] == "10") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al almacenar el tipo de sexo";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.router.navigate(['/']);
        } else {
          let dlgAviso = this.dialog.open(DlgAvisoComponent, {
            width: '600px',
            disableClose: true
          });
          dlgAviso.componentInstance.titulo = "Aviso del sistema";
          dlgAviso.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.cerrar('almaceno');
        }
      },
        (error: HttpErrorResponse) => {
          this.cerrarDialogo(dlgTrabajando);
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          if (error.status.toString() == "401") {
            dlgError.componentInstance.titulo = "Error al almacenar el dato del tipo de sexo";
            dlgError.componentInstance.texto = "Su sesión ha finalizado";
            this.router.navigate(['/']);
          } else {
            dlgError.componentInstance.titulo = "Error al almacenar el dato del tipo de sexo";
            dlgError.componentInstance.texto = error.message + " (" + error.status + ")";
          }
        }
      );
  }
}
